<template>
  <div>
    <b-modal
        ref="modal"
        size="lg"
        hide-footer
        title="Detalhes de Sincronização"
        centered
        dialog-class="sync-view-modal"
    >
      <div class="d-flex justify-content-between align-items-start mb-2 modal-header-inline">
        <div>
          <h5 class="mb-0">{{ video.titulo || 'Vídeo' }}</h5>
          <small class="text-muted">{{ video.descricao }}</small>
        </div>
      </div>

      <div
          v-if="loading"
          class="d-flex flex-column align-items-center justify-content-center loading-area"
      >
        <b-spinner small type="grow" class="mb-2"/>
        <span>Carregando dados de sincronização...</span>
      </div>

      <div v-else>
        <div
            v-if="!syncData.length"
            class="text-center py-4 text-muted"
        >
          Nenhum dado de sincronização encontrado
        </div>

        <div v-else>
          <b-list-group>
            <b-list-group-item
                v-for="(item, idx) in syncData"
                :key="idx"
                class="d-flex flex-column sync-item"
            >
              <div class="d-flex justify-content-between align-items-center mb-1">
                <strong>{{ item.unidade_nome || 'N/A' }}</strong>
                <div>
                  <i v-if="item.sincronizado" class="fas fa-check-circle text-success fa-lg" title="Sincronizado"></i>
                  <i v-else class="fas fa-times-circle text-danger fa-lg" title="Não sincronizado"></i>
                </div>
              </div>

              <div class="d-flex flex-column flex-md-row justify-content-between small text-muted">
                <div class="mr-md-3">
                  <span class="label">Dispositivo:</span>
                  <span v-if="item.painel_nome || item.totem_nome">
                    <span v-if="item.painel_nome">
                      <i class="fas fa-tv text-info"></i> {{ item.painel_nome }}
                    </span>
                    <span v-if="item.painel_nome && item.totem_nome"> · </span>
                    <span v-if="item.totem_nome">
                      <i class="fas fa-desktop text-success"></i> {{ item.totem_nome }}
                    </span>
                  </span>
                  <span v-else>N/A</span>
                </div>

                <div class="mt-1 mt-md-0">
                  <span class="label">Última sincronização:</span>
                  <span>{{ item.sincronizado_em ? formatDate(item.sincronizado_em) : 'Nunca' }}</span>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import {
  BModal,
  BSpinner,
  BListGroup,
  BListGroupItem
} from 'bootstrap-vue';

export default {
  name: 'VideoSyncView',
  components: {
    BModal,
    BSpinner,
    BListGroup,
    BListGroupItem
  },
  data() {
    return {
      video: {},
      syncData: [],
      loading: false
    };
  },
  methods: {
    open(videoId) {
      this.video = {};
      this.syncData = [];
      this.loading = true;
      this.$refs.modal.show();

      const api = this.$store.state.api + `videos/${videoId}/sync-status`;
      axios.get(api)
          .then(response => {
            const data = response.data.data || response.data || [];
            this.syncData = Array.isArray(data) ? data : [];
            if (this.syncData.length > 0 && this.syncData[0].video) {
              this.video = this.syncData[0].video;
            }
          })
          .catch(error => {
            this.$message && this.$message("Erro", "Erro ao carregar dados de sincronização", "error");
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      try {
        const date = new Date(dateString);
        return date.toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        return dateString;
      }
    }
  }
};
</script>

<style scoped>
.sync-view-modal .modal-header-inline {
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.loading-area {
  min-height: 200px;
}

.sync-item {
  margin-bottom: 0.5rem;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.sync-item:hover {
  background-color: #f8f9fa;
}

.label {
  font-weight: 600;
  margin-right: 0.5rem;
}

@media (max-width: 768px) {
  .modal-header-inline {
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
